var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c(
        "el-radio-group",
        {
          on: { change: _vm.set },
          model: {
            value: _vm.currentValue,
            callback: function($$v) {
              _vm.currentValue = $$v
            },
            expression: "currentValue"
          }
        },
        [
          _c("el-radio-button", { attrs: { label: "default" } }),
          _c("el-radio-button", { attrs: { label: "medium" } }),
          _c("el-radio-button", { attrs: { label: "small" } }),
          _c("el-radio-button", { attrs: { label: "mini" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }